import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import type TeamModel from 'scaleflow/models/team';
import type StoreService from 'scaleflow/services/store';
import type Controller from '@ember/controller';
class OperationsTeamsTeamRoadmapRoute extends Route {
  @service declare store: StoreService;

  model() {
    const team = this.modelFor('operations.teams.team') as TeamModel;
    const initiativeIds = (team as any).hasMany('initiatives').ids();
    return Promise.allSettled(
      initiativeIds.map((id: string) =>
        this.store.findRecord('initiative', id).catch(() => undefined),
      ),
    )
      .then((results) => results.map((item: any) => item.value))
      .then((results) => results.filter((result) => result));
  }

  setupController(controller: Controller, model: any) {
    super.setupController(controller, model);
    controller.set('team', this.modelFor('operations.teams.team'));
  }
}

export default instrumentRoutePerformance(OperationsTeamsTeamRoadmapRoute);
